export default __webpack_public_path__ + "2beec68fe07cc0f405445c7a408f121a.png";